import { EditAccountFormValues, NewAccountFormValues } from '../models'

export const CHECK_ACH_DEFAULTS = {
  checkDecision: 'RETURN',
  checkReason: 'PDIR',
  staleDatedDays: '180',
  payeeMatch: true,
  achDecision: 'RETURN',
  achReason: 'PDIR',
} as const

export const defaultValues: Partial<NewAccountFormValues> = {
  clientName: undefined,
  accountName: undefined,
  accountNumber: undefined,
  displayNotes: '',
  serviceTypeParameter: undefined,
  checkExceptionProcessingType: undefined,
  checkDecision: CHECK_ACH_DEFAULTS.checkDecision,
  checkReason: CHECK_ACH_DEFAULTS.checkReason,
  staleDatedDays: CHECK_ACH_DEFAULTS.staleDatedDays,
  payeeMatch: CHECK_ACH_DEFAULTS.payeeMatch,
  achExceptionProcessingType: undefined,
  achDecision: CHECK_ACH_DEFAULTS.achDecision,
  achReason: CHECK_ACH_DEFAULTS.achReason,
}

export const defaultEditValues: Partial<EditAccountFormValues> = {
  ...defaultValues,
  isArchiveAccount: false,
}

export const PROCESSING_TYPES = {
  NOCREATE: 'NOCREATE',
  CREATE: 'CREATE',
}

export const ACCOUNT_STATUS = {
  ACTIVE: 0,
  ARCHIVE: 1,
}
